// extracted by mini-css-extract-plugin
module.exports = {"icon":"statusMessage_icon__1GvS7"};